<template>
	<md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <div class="flex items-center justify-between w-full">
                    <span class="font-bold">Dispositifs</span>
                    <div class="flex items-center">
                        <div class="mr-2">
                            <md-button class="md-icon-button md-raised md-warning"
                                       @click="goToRoute('Site Devices Edit', { idSite })">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                            </md-button>
                            <md-tooltip md-direction="top">Gérer les dispositifs</md-tooltip>
                        </div>
                        <div>
                            <md-button class="md-icon-button md-raised md-default"
                                       @click="goToRoute('Site Devices Products Edit', { idSite })">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'file-alt']" />
                            </md-button>
                            <md-tooltip md-direction="top">Gérer les produits</md-tooltip>
                        </div>
                    </div>
                </div>
                <md-table v-model="devices" class="md-table-devices" table-header-color="blue" v-if="devices.length > 0">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="N°">
                            <span>{{ item.number }}</span>
                        </md-table-cell>
                        <md-table-cell md-label="" style="max-width: 25px;">
                            <img :src="item.current_device_type.icon" alt="picto" />
                        </md-table-cell>
                        <md-table-cell md-label="Localisation" style="min-width: 260px;">
                            {{ item.location }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <p v-else>Aucun dispositif sur ce site</p>
            </div>
            <div class="md-layout-item md-size-50">
                <div class="flex items-center justify-between w-full">
                    <span class="font-bold">Plans</span>
                    <div>
                        <md-button class="md-icon-button md-raised md-info" @click="goToRoute('Site Plan Add', { idSite })">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                        </md-button>
                        <md-tooltip md-direction="top">Ajouter un plan</md-tooltip>
                    </div>
                </div>
                <md-table v-model="plans" table-header-color="blue" v-if="plans.length > 0">
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Nom">
                            <a class="text-info" :href="item.url" target="_blank">
                                {{ item.name }}
                            </a>
                        </md-table-cell>
                        <md-table-cell md-label="">
                            <div class="flex items-center justify-end">
                                <div class="mr-2">
                                    <md-button class="md-icon-button md-raised md-warning"
                                               @click="goToRoute('Site Plan Edit', { documentId: item.id })">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                                    </md-button>
                                    <md-tooltip md-direction="top">Gérer</md-tooltip>
                                </div>
                                <plan-button-pdf class="mr-2" :planId="item.id"></plan-button-pdf>
                                <div>
                                    <md-button class="md-icon-button md-raised md-danger" @click="deletePlan(item.id)">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'trash']" />
                                    </md-button>
                                    <md-tooltip md-direction="top">Supprimer</md-tooltip>
                                </div>
                            </div>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <p v-else>Aucun plan sur ce site</p>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import PlanButtonPdf from "@/pages/Sites/Devices/Plans/components/PlanButtonPdf";
export default {
	name: "Devices",
    components: {
        PlanButtonPdf,
    },
	props: {
		idSite: Number,
		devices: Array,
        plans: Array
	},
	methods: {
	    async deletePlan(id) {
	        try {
                await this.$store.dispatch('site_documents/deletePlan', {
                    documentId: id
                })
                await this.$store.dispatch('alerts/success', 'Plan supprimé')
                this.$emit('deleted-plan')
            } catch (e) {
            }
        },
		goToRoute(route, params = null) {
			this.$router.push({ name: route, params })
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-table {
        &.md-table-devices {
            thead tr th:first-child,
            tbody tr td:first-child {
                padding-left: 0;
            }

            .md-table-cell {
                max-height: 35px;
                height: 35px;

                img {
                    max-width: 20px;
                }
            }
        }

        .md-table-content {
            thead tr th, tbody tr td {
                padding-top: 0;
                padding-bottom: 0;
            }

            .md-table-head-label {
                font-size: 1rem;
                padding: 0;
            }
        }
    }
}
</style>
